import { Injectable } from "@angular/core";
import { CanActivate, Router, UrlTree } from "@angular/router";
import { Contract } from "@edp-components/edp-contract";
import { EdpUser } from "@edp-models/user.model";
import { GetContracts } from "@edp-store/actions/contract.actions";
import { getContracts } from "@edp-store/selectors/contract.selectors";
import { getUser } from "@edp-store/selectors/user.selectors";
import { IAppState } from "@edp-store/state/app.state";
import { select, Store } from "@ngrx/store";
import { Observable, of } from "rxjs";
import { filter, map, switchMap, take, withLatestFrom } from "rxjs/operators";

@Injectable({
    providedIn: "root",
})
export class EdpAuthPlaneta implements CanActivate {

    constructor(private store: Store<IAppState>, private router: Router) {}

    canActivate(): Observable<any> | Promise<any> | boolean | UrlTree {

        return this.store.select(getUser).pipe(
            filter((user: EdpUser) => user !== null),
            withLatestFrom(this.store.pipe(select(getContracts), take(1))),
            switchMap(([user, contracts]: [EdpUser, Contract[]]) => {
                if (contracts.length) {
                    return of([contracts, user]);
                } else {
                    this.store.dispatch(new GetContracts());
                    return this.store.pipe(select(getContracts),
                        filter((contracts: Contract[]) => contracts.length > 0),
                        withLatestFrom(this.store.select(getUser))
                    );
                }
            }),
            map(([contracts, user]: [Contract[], EdpUser]) => {
                const activeContracts = contracts.filter(contract => contract.isActivo());
                if (user.segment !== "B2C" || activeContracts.length === 0) {
                    return this.router.parseUrl("/energia/inicio");
                } else if (user.partnerNumber) {
                    if (!user.edpESubscribed) {
                        return this.router.parseUrl("/planeta-zero/inscricao");
                    } else {
                        return true;
                    }
                }
            })
        );
    }
}
